
var params;

export function generate(config: any) {
    params = config;
    return ""
}


